module.exports = __webpack_public_path__ + "img/kufri-grey1.f0de6d6.webp";